import Vue from "vue";
import VueInternationalization from "vue-i18n";
import env from "@chronos/frontend-base/src/libs/tools/Environment";
class Localization {
  constructor() {
    this.init();
  }
  getLanguage() {
    return window.APP_ENV.lang ? window.APP_ENV.lang : "en";
  }
  init() {
    Vue.use(VueInternationalization);
    this.language = this.getLanguage();
    this.message = require("@/html_locales/" + this.language + ".json");
    const messages = {
      [this.language]: this.message,
    };
    const i18n = new VueInternationalization({
      locale: this.language,
      messages,
      fallbackLocale: env.isMyGames ? "en": "ru",
      pluralizationRules: {
        /**
         * @param choice {number} индекс выбора, переданный в $tc: `$tc('path.to.rule', choiceIndex)`
         * @param choicesLength {number} общее количество доступных вариантов
         * @returns финальный индекс для выбора соответственного варианта слова
         */
        ru: function(choice, choicesLength) {
          if (choice === 0) {
            return 0;
          }

          const teen = choice > 10 && choice < 20;
          const endsWithOne = choice % 10 === 1;

          if (choicesLength < 4) {
            return !teen && endsWithOne ? 1 : 2;
          }
          if (!teen && endsWithOne) {
            return 1;
          }
          if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
            return 2;
          }

          return choicesLength < 4 ? 2 : 3;
        },
      },
    });
    this.i18n = i18n;

    return i18n;
  }
}
const localization = new Localization();
export default localization.init();

